export const daysOfWeek: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const daysOfWeekLowerCase: string[] = daysOfWeek.map((day) => day.toLowerCase());
export const daysOfWeekUpperCase: string[] = daysOfWeek.map((day) => day.toUpperCase());
